import { render, staticRenderFns } from "./CrossSell.vue?vue&type=template&id=83184fe0&scoped=true&"
import script from "./CrossSell.vue?vue&type=script&lang=js&"
export * from "./CrossSell.vue?vue&type=script&lang=js&"
import style0 from "./CrossSell.vue?vue&type=style&index=0&id=83184fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83184fe0",
  null
  
)

export default component.exports